<script>
import CategoryInputs from './category-inputs'
import SortableList from './sortable-list'
import SortableItem from './sortable-item'
import { mapActions } from 'vuex'

export default {
  name: 'TiersInputs',
  components: {
    CategoryInputs,
    SortableItem,
    SortableList,
  },
  props: {
    groupIndex: {
      type: Number,
      default: null,
    },
    value: {
      type: Array,
      default: () => [],
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tiers: [],
    }
  },
  computed: {
    bracketHeight() {
      if (!this.tiers.length) return
      const inputHeight = 40; const inputMargin = 24
      const addHeight = 18 + 8 // height + margin
      // Ignore last tier in braket calculation
      let height = (this.tiers.length - 1) * (addHeight)
      for (let i = 0; i < this.tiers.length - 1; i++) {
        const items = this.tiers[i].items && this.tiers[i].items.length
        if (items) {
          height += (inputHeight + inputMargin) * items
        }
      }
      return `${height}px`
    },
    propPrefix() {
      return (typeof this.groupIndex === 'number') ? `[${this.groupIndex}].items` : ''
    },
  },
  watch: {
    value: {
      handler(val) {
        this.tiers = val
      },
      deep: true,
    },
  },
  mounted() {
    this.tiers = this.value
  },
  methods: {
    ...mapActions('category', ['addItem', 'removeItem', 'sortItem']),
    sortEnd({ oldIndex, newIndex }) {
      this.sortItem({ oldIndex, newIndex, groupIndex: this.groupIndex })
    },
  },
}
</script>

<template>
  <div :class="$style.root">
    <div
      :class="[$style.bracket, {[$style.singleItem] : tiers.length === 1}]"
      :style="`height:${bracketHeight}`"
    />
    <div
      v-show="!viewMode"
      :class="$style.add"
      @mousedown.stop=""
      @click="addItem({itemType: 'tier', groupIndex})"
    >
      + Add Tier
    </div>
    <sortable-list
      v-model="tiers"
      :class="$style.tiers"
      :disabled="viewMode"
      @sort-end="sortEnd"
    >
      <sortable-item
        v-for="(tier, index) in tiers"
        :key="index"
        :index="index"
        :disabled="viewMode"
        :class="$style.tier"
      >
        <el-form-item
          :class="$style.input"
          :prop="`tree${propPrefix}[${index}].name`"
        >
          <el-input
            v-model="tier.name"
            :disabled="viewMode"
            :class="[$style.inputMargin, {[$style.disabledInput]: viewMode}]"
          />
          <template v-if="tiers.length > 1 && !viewMode">
            <i :class="['el-icon-d-caret', $style.icon, $style.iconDrag]" />
            <i
              :class="['el-icon-delete', $style.icon, $style.iconDel]"
              @mousedown.stop=""
              @click="removeItem({itemType: 'tier', groupIndex, index})"
            />
          </template>
        </el-form-item>

        <category-inputs
          v-model="tier.items"
          :view-mode="viewMode"
          :group-index="groupIndex"
          :tier-index="index"
        />
      </sortable-item>
    </sortable-list>
  </div>
</template>

<style lang="scss" module>
.root {
  position: relative;
  display: grid;
  grid-template-areas:
    "brackets tiers";
  grid-template-columns: 30px 450px;
  grid-column-gap: 10px;
}

.add {
  position: absolute;
  z-index: 1;
  width: 240px;
  margin-bottom: rem(8px);
  font-weight: bold;
  color: var(--color-primary);
  text-align: right;
  cursor: pointer;
}

.bracket {
  grid-area: brackets;
  margin: rem(46px 0 0);
  border: 1px solid var(--color-dark-gray);
  border-right-width: 0;
}

.singleItem {
  min-height: 2px;
  border-bottom-width: 0;
}

.tiers {
  grid-area: tiers;
}

.tier {
  display: grid;
  grid-template-columns: 200px 240px;
  grid-column-gap: 40px;
}

.inputMargin {
  margin-top: rem(26px);
}

.input {
  position: relative;
  margin-bottom: rem(8px);
}

.disabledInput {
  :global {
    .el-input__inner {
      color: var(--color-text) !important;
    }
  }
}

.icon {
  position: absolute;
  top: rem(46px);
  right: 0;
  color: var(--color-primary);
  cursor: pointer;
  transform: translateY(-50%);
}

.iconDel {
  right: rem(6px);
}

.iconDrag {
  right: rem(24px);
}

</style>
